/* eslint-disable */
import 'bootstrap/js/src/modal.js';
(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.now_products = {
    attach: function (context, settings) {
      once('products-js-init', 'body', context).forEach(function() {
        const $mainCanvas = jQuery('body .dialog-off-canvas-main-canvas').first();
        const $body = jQuery('body');

        $(document).ready(function () {
          $('.structured-fact-panel-table.large-only p').each(function () {
            const $p = $(this);
            const $spans = $p.find('span.line-indent-1');
            if ($spans.length < 2) return; // skip if fewer than 2 spans

            const $first = $spans.first();
            const $last = $spans.last();

            // Grab everything from first → last (inclusive)
            const $toWrap = $first.nextUntil($last).addBack().add($last);

            // Wrap them in one new span
            $toWrap.wrapAll('<span class="line-indent-1"></span>');

            // Remove all .line-indent-1 classes inside wrapper
            $p.find('> .line-indent-1 span.line-indent-1').removeClass('line-indent-1');

            $p.find('*').addBack().contents().filter(function() {
              return this.nodeType === Node.TEXT_NODE;
            }).each(function() {
              this.nodeValue = this.nodeValue.replace(/\u00A0/g, ' ');
            });
          });
        });

        function overlayOn() {
          if (!$mainCanvas.hasClass('overlay-blur')) {
            $mainCanvas.addClass('overlay-blur');
          }
          if (!$body.hasClass('no-scroll')) {
            $body.addClass('no-scroll');
          }
        }

        function overlayOff() {
          if ($mainCanvas.hasClass('overlay-blur')) {
            $mainCanvas.removeClass('overlay-blur');
          }
          if ($body.hasClass('no-scroll')) {
            $body.removeClass('no-scroll');
          }
        }

        function updatePrice() {
          let $regular_price = jQuery('.product-info--commerce').find('.field--name-price').first();
          jQuery('.field--name-calculated-price').append($regular_price);
        }

        // Function updates Modal on page load
        // Selectors updated due to maintenance stripping out classes that were previously referenced to trigger this function - JH 2024-01-16
        function updateModal() {
          let $confirmation_modal = jQuery('.commerce-add-to-cart-confirmation').first();
          let $confirmation_modal2 = $confirmation_modal.parent();

          overlayOn();

          $(once('confirm-add', $confirmation_modal2)).css({
            'width': '100%',
            'top': '50%',
            'left': '50%',
            'transform': 'translate(-50%, -50%)'
          });

          jQuery('.ui-widget-overlay').click(function() {
            overlayOff();
            $confirmation_modal.hide();
            $confirmation_modal.remove();
            jQuery('html').css('overflow', 'auto');
          });

          jQuery($confirmation_modal).on('dialogclose', function() {
            overlayOff();
          });

          let $confirmation_modal_message = jQuery('.commerce-add-to-cart-confirmation').first();
          $(once('confirm-add-message', $confirmation_modal_message)).css('height', 'auto');

          if ($('.add-to-cart-modal .sale').length > 0) {
            // append reg price to sales price if present
            let $regular_price = jQuery('.modal-content .field--name-price').first();
            jQuery('.add-to-cart-modal .field--name-calculated-price').append($regular_price);
          }

          $('.add-to-cart-modal .form-radios label').each(function() {
            $(this).on('click', function() {
              $(document).ajaxComplete(function (event, xhr, settings) {
                if ($('.add-to-cart-modal .sale').length > 0) {
                  // Ensure the AJAX request for the specific form completes before running updating price
                  let $regular_price = jQuery('.modal-content .field--name-price').first();
                  jQuery('.add-to-cart-modal .field--name-calculated-price').append($regular_price);
                }
              });
            });
          });
        }

        const productsInit = function() {
          jQuery('.add-to-cart-modal').on('shown.bs.modal', function (e) {
            overlayOn();
            const $modal = jQuery(this);
            const $node = $modal.closest('.node');
            const $productForm = $node.find('.field--name-field-product-reference').first();
            $modal.find('.modal-body').append($productForm);
            const $btn = $modal.find('.button--add-to-cart');
            const productName = $modal.attr('data-product-name');
            if (!$btn.hasClass('now-btn-primary')) {
              $btn.html('Add <span class="sr-only">' + productName + '</span> to Cart');
              $btn.addClass('now-btn-primary');
              // move up to the body
              // to avoid fixed elements getting trapped in relative ones
              jQuery('body').append($modal);
            }
          });

          jQuery('.add-to-cart-modal').on('hide.bs.modal', function (e) {
            const $modal = jQuery(this);
            const $node = $modal.closest('.node');
            const $productForm = $node.find('.field--name-field-product-reference');
            $node.find('.product--content').append($productForm);
            overlayOff();
          });

          jQuery('.ui-dialog-titlebar-close').on('click', function() {
            jQuery('.dialog-off-canvas-main-canvas').removeClass('overlay-blur');
            jQuery('html').css('overflow', 'auto');
            $body.removeClass('no-scroll');
          });

          jQuery('.commerce-order-item-add-to-cart-form .webform-dialog-narrow').first().on('click', function (e) {
            overlayOn();
            $(document).ajaxComplete(function() {
              jQuery('.ui-dialog').addClass('product-email-notify-dialog');

              let $confirmation_modal = jQuery('.product-email-notify-dialog').first();
              $confirmation_modal.find('.webform-actions').first().once('wrap-image').each(function() {
                $(this).nextUntil('input').wrapAll('<div class="product-info"></div>');
                jQuery('.js-form-item-product-thumbnail').nextUntil('input').wrapAll('<div class="product-copy"></div>');
              });

              jQuery($confirmation_modal).on('remove', function() {
                overlayOff();
              });

              jQuery('.ui-widget-overlay').click(function() {
                $confirmation_modal.remove();
              });
            });
          });

          $(once('view-more', '.js-view-more', context)).on('click', function (e) {
            let $parent_wrapper = jQuery(this).parent();
            if ($parent_wrapper.hasClass('expanded')) {
              $parent_wrapper.removeClass('expanded');
              jQuery(this).text('Read more');
            }
            else {
              $parent_wrapper.addClass('expanded');
              jQuery(this).text('Read less');
            }
          });

          let $promo_input = jQuery('input[name="coupon_redemption[code]"]');
          let $promo_input_2 = jQuery('input[name="sidebar[coupon_redemption][form][code]"]');
          let $apply_promo = jQuery('button[name="apply_coupon"]');

          if ($promo_input) {
            if ($promo_input.val() === '') {
              $apply_promo.attr('disabled', true);
            }

            $promo_input.keyup(function() {
              if ($promo_input.val() !== '') {
                $apply_promo.attr('disabled', false);
              }
              else {
                $apply_promo.attr('disabled', true);
              }
            });
          }

          if ($promo_input_2) {
            if ($promo_input_2.val() === '') {
              $apply_promo.attr('disabled', true);
            }

            $promo_input_2.keyup(function() {
              if ($promo_input_2.val() !== '') {
                $apply_promo.attr('disabled', false);
              }
              else {
                $apply_promo.attr('disabled', true);
              }
            });
          }

          // Check if the page is product full view, if so wait for loaded modal
          if (jQuery('.node--view-mode-full').length > 0) {
            // Selectors updated due to maintenance stripping out classes that were previously referenced to trigger this function - JH 2024-01-16
            let $data_once = $('body').attr('data-once');
            // Check if the value matches a specific string
            if ($data_once.includes('commerce-add-to-cart-confirmation')) {
              let existCondition = setInterval(function() {
                if (jQuery('.ui-dialog').length) {
                  clearInterval(existCondition);
                  updateModal();
                }
              }, 100);
            }
          }

          // Add blur overlay for when product is clicked via the carousel
          jQuery('.trigger-add-to-cart-modal').click(function() {
            overlayOn();

            let check_overlay = setInterval(function() {
              if (jQuery('.modal-backdrop').length) {
                clearInterval(check_overlay);
                jQuery('.modal-backdrop').removeClass('show');
              }
            }, 100);
          });
        };

        /*
          JS added to push outof stock radios to checked, only fires on products where all options
          are out of stock to avoid interfering with AJAX throbber functionality in place for items
          that can be added to card
        */
        if (jQuery('.button--add-to-cart').length === 0) {

          $('.commerce-order-item-add-to-cart-form .form-radios .option').once('select-product-option').on('click', function() {
            jQuery(this).siblings('input').prop('checked', true);
          });
        }

        if (jQuery('.view-commerce-cart-form').length > 0 || jQuery('.commerce-add-to-cart-confirmation').length > 0) {
          var now = new Date().getTime();
          let existCondition = setInterval(function() {
            if (jQuery('.commerce-confirmation-popup').length) {
              clearInterval(existCondition);
              updateModal();
            }
            else if (new Date().getTime() - now > 1000) {
              clearInterval(existCondition);
            }
          }, 100);
        }

        // Inject product sizes into product cards
        if (jQuery('.product-size-inject').length > 0) {
          jQuery('.product-size-inject').each(function() {
            let $parent_div = jQuery(this).parent();
            let $product_sizes = $parent_div.find('.product-price-range > .product-size').first().text();

            jQuery(this).text($product_sizes);
          });
        }

        // // mutation observer to watch for changes DOM
        let target = document.querySelector('body');
        let config = { attributes: true, childList: true, subtree: true };
        let observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type === 'childList') {
              jQuery('.commerce-order-item-add-to-cart-form .webform-dialog-narrow').first().on('click', function (e) {
                overlayOn();
                $(document).ajaxComplete(function() {
                  jQuery('.ui-dialog').addClass('product-email-notify-dialog');

                  let $confirmation_modal = jQuery('.product-email-notify-dialog').first();
                  $confirmation_modal.find('.webform-actions').first().once('wrap-image').each(function() {
                    $(this).nextUntil('input').wrapAll('<div class="product-info"></div>');
                    jQuery('.js-form-item-product-thumbnail').nextUntil('input').wrapAll('<div class="product-copy"></div>');
                  });

                  jQuery($confirmation_modal).on('remove', function() {
                    overlayOff();
                  });

                  jQuery('.ui-widget-overlay').click(function() {
                    $confirmation_modal.remove();
                  });
                });
              });
              jQuery('.add-to-cart-modal').on('remove', function() {
                overlayOff();
              });
            }
          });
        });
        observer.observe(target, config);

        // if a hash is in the url, scroll to it on page load to show the reviews
        if (window.location.hash && jQuery('.page-node-type-now-foods-product').length > 0) {
          let hash = window.location.hash;
          setTimeout(function() {
            jQuery('html, body').animate({
              scrollTop: jQuery(hash).offset().top
            }, 1000);
          }, 1000);
        }

        if (jQuery('.page-node-type-now-foods-product').length > 0 &&
          jQuery('.sale').length > 0) {
          updatePrice();
        }

        if (jQuery('.product-thumbnail .commerce-order-item-variation-cart-form-form').length > 0) {
          jQuery('.product-thumbnail .commerce-order-item-variation-cart-form-form').each(function() {
            jQuery(this).find('input, button').removeAttr('disabled');
          });
        }

        // JH - 2024-10-16 - When a variation is selected in the product add to cart modal, update the view product details link to include the param VARI with the selected variation
        jQuery('.add-to-cart-modal').each(function() {
          let $modal = jQuery(this);
          let $product_detail_link = $modal.find('.product-details-link').first();

          $modal.find('.option').each(function() {
            jQuery(this).once('update-details-link').on('click', function() {
              let variation = jQuery(this).prev('input').val();
              let href = $product_detail_link.attr('href');
              // remove any arguments from href and update
              href = href.split('?')[0];
              href = href + '?VARI=' + variation;
              $product_detail_link.attr('href', href);
            });
          });
        });

        // If the PARAMETER 'VARI' is in the URL find the label that has the variation value in its 'for' attribute and click it
        let variation_selected = false;
        if (window.location.search.indexOf('VARI') > -1 && !variation_selected) {
          let urlParams = new URLSearchParams(window.location.search);
          let variation = urlParams.get('VARI');
          let $label = jQuery('label[for="edit-purchased-entity-0-variation-' + variation + '"]');
          setTimeout(function() {
            $label.once('select_variation').trigger('click');
          }, 200);
          variation_selected = true;
        }

        // If the PARAMETER 'SKU' is in the URL find the label that has the sku value in its 'for' attribute and click it
        let sku_selected = false;
        if (window.location.search.indexOf('SKU') > -1 && !sku_selected) {
          let urlParams = new URLSearchParams(window.location.search);
          let sku = urlParams.get('SKU');
          let $label = jQuery('span[data-sku="' + sku + '"]').closest('label');
          setTimeout(function() {
            $label.once('select_sku').trigger('click');
          }, 200);
          sku_selected = true;
        }


        $('.commerce-order-item-add-to-cart-form .form-radios label').each(function() {
          $(this).on('click', function() {
            $(document).ajaxComplete(function (event, xhr, settings) {
              if ($('.product-info--commerce .sale').length > 0) {
                // Ensure the AJAX request for the specific form completes before running updating price
                let $regular_price = jQuery('.field--name-price').first();
                jQuery('.field--name-calculated-price').append($regular_price);
              }
            });
          });
        });

        // JH 2024-10-16 - This is the same code that is present in the custom 'nowfoods_destini' Module, however, for some reason in the module it is trigger a page refresh which loads the 'Added to cart modal', code replicated here to avoid the page refresh
        jQuery('.destini-modal-toggle').click(function (e) {
          e.preventDefault();
          const $btn = jQuery(this);
          if ($btn.attr('data-destini-init') !== 'true') {
            $btn.attr('data-destini-init', 'true');
            var containerId = $btn.attr('data-destini-container');
            var associationId = $btn.attr('data-destini-association');
            var modalId = $btn.attr('data-target');
            var APO = $btn.attr('data-destini-apo');
            destini.init(containerId);
            destini.loadWidget(associationId, APO);
            jQuery(modalId).modal('show');
          }
        });
        productsInit();
      });
    }
  };
})(jQuery, Drupal, once);
